import React from 'react';
import './Tesseract.scss';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { injectIntl } from 'react-intl';
import { faImage, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import * as actions from "store/actions/index";
import Spinner from 'Flow2/components/UI/Spinner/Spinner';

class Tesseract extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            popUpObjects: {},
            requiredObj: {},
            data: [],
            loading: true,
            ocrData: null
        }
    }

    getBodyClasses = () => "tesseract-body";

    updateOcrData = (ocrData) => {
        this.setState({ ocrData }, () => setTimeout(() => {
            this.setState({ loading: false });
        }, 10));
    }

    initData = () => {
        const { clip } = this.props;
        this.setState({ loading: true });
        if (clip && clip.metadata && clip.metadata.ocr && clip.metadata.ocr != "") {
            this.updateOcrData(clip.metadata.ocr);
        }
    }

    onCloseBtnClick = () => {
        this.props.updatePopUpObjects({
            [`${this.props.subObjName}`]: { showOverlay: false },
        });
        if (this.props.cancelCallback) this.props.cancelCallback();
    }


    showHeader = () => {
        return (
            <div className="tesseract-header">
                <div className="tesseract-icontop" onClick={this.onCloseBtnClick}>
                    <FontAwesomeIcon icon={faTimesCircle} />
                </div>
            </div>)
    }

    showBody = () => {
        return (
            <div className={this.getBodyClasses()}>
                <pre>
                    {this.state.ocrData}
                </pre>
            </div>)
    }


    componentDidUpdate(prev) {
        const { aiTesseract } = this.props.aiObjects;
        if (prev.aiObjects.aiTesseract.ocr != aiTesseract.ocr) {
            this.updateOcrData(aiTesseract.ocr);
        }

        if (prev.loading !== this.props.loading) {
            this.setState({ loading: this.props.loading });
        }

        if (prev.clip != this.props.clip) {
            this.initData();
        }
    }

    componentDidMount() {
        this.initData();
    }

    componentWillUnmount() {
        this.onCloseBtnClick();
    }

    showFooter = () => {
        return (
            <div className="custom-footer" >
                <FontAwesomeIcon icon={faImage} />
            </div>)
    }

    showPreview = () => {
        if (!this.state.loading && this.state.ocrData) {
            return (
                <div className="tesseract-preview">
                    {this.showHeader()}
                    {this.showBody()}
                </div>
            )
        }
    }

    render() {
        if (this.props.mainObj[`${this.props.subObjName}`].showOverlay)
            return (
                <div className="Tesseract">
                    <div className="tesseract-overlay">
                        {this.state.loading && (
                            <div className="tesseract-spinner-overlay">
                                <Spinner />
                            </div>
                        )}
                        {this.showPreview()}
                    </div>
                </div>
            );
        return null;
    }

}

const mapStateToprops = (state) => ({
    aiObjects: state.ai.aiObjects,
    loading: state.ai.loading,
    clip: state.clip.currentClip,

})
const mapDispatchToProps = (dispatch) => ({
    updateAiObjects: (obj) => dispatch(actions.updateAiObjects(obj)),
})

export default connect(mapStateToprops, mapDispatchToProps)(injectIntl(Tesseract));